import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addRechargeConfig from "./components/addRechargeConfig";
export default {
  name: "rechargeConfig",
  mixins: [loadMoreList, serchSelect],
  components: {
    addRechargeConfig: addRechargeConfig
  },
  data: function data() {
    return {
      pagingReqFn: "rechargeWebsiteConfigData",
      pagingReqValue: "" // tableBody:'topBannerTable',
      // sortReq:'bannerChangeSort'

    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'rechargeWebsiteConfigDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};